var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8 15.125C7.7019 15.1239 7.41624 15.0054 7.205 14.795L1.205 8.79502C0.992471 8.58507 0.872854 8.29876 0.872854 8.00002C0.872854 7.70127 0.992471 7.41497 1.205 7.20502L7.205 1.20502C7.48546 0.904037 7.90783 0.780143 8.30643 0.881938C8.70503 0.983734 9.01628 1.29498 9.11808 1.69358C9.21987 2.09218 9.09598 2.51456 8.795 2.79502L3.59 8.00002L8.795 13.205C9.00753 13.415 9.12715 13.7013 9.12715 14C9.12715 14.2988 9.00753 14.5851 8.795 14.795C8.58376 15.0054 8.2981 15.1239 8 15.125Z",
    fill: "#6BA6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.bed417db1bcf9a0fc19882bac5e4ab34.svg";
export { ForwardRef as ReactComponent };